import React from 'react';
import Relay from 'react-relay';

import RelayStore from '../../RelayStore'
import UserPanel, { isValidEmailAddress } from '../../components/UserPanel';
import UpdateUserMutation from '../../mutations/User/UpdateUserMutation';

class EditUser extends React.Component {

  constructor(props) {
    super(props);
  }

  componentWillMount() {
    this.props.relay.setVariables({
      userId: this.props.location.state.userId,
      queryUser: true,
    })
  }

  onUpdateUser = (user) => {
    const { viewer } = this.props;
    let validatePublicActivities = user.isTrustedUserToCreateActivities;
    let validatePublicGroups = user.isTrustedUserToCreateCircles;
    let isTrustedUserToMakeMoneyTransferToAnyone = user.isTrustedUserToMakeMoneyTransferToAnyone;
		let statusField = {
			status: user.creation_status.status,
			reason: user.creation_status.reason ? user.creation_status.reason : ''
		};
    let feesField = user.fees ;
		let sportsField =
			user.sports.map(sport => {
				let sportId = sport.sport.id;
				let certificates = sport.certificates.map(certificate => {return {certificate: certificate.certificate.id, validation: certificate.validation}});
				let positions = sport.positions.map(position => position.id);
				let levels = sport.levels.map(level => level.id);
				return {
					sport: sportId,
					certificates: certificates,
					positions: positions,
					levels: levels
				};
			});

		let mutation = new UpdateUserMutation({viewer, user, statusField, sportsField, feesField, validatePublicActivities, validatePublicGroups, isTrustedUserToMakeMoneyTransferToAnyone});

  	RelayStore.commitUpdate( mutation, {
		onFailure: (error) => {
			console.log('error', error.getError());
			alert('Update Failed');
		},
		onSuccess: (response) => {
			console.log('success', response);
			alert('Update Success');
		}
  	});
  }

  
  render() {
    const { viewer, router } = this.props;
    const { user } = viewer;
    if (!user) return null
    console.log("User in editUser", this.props.viewer.user)
    return (
        <div className="panel" style={{marginTop:20}}>
          {this.props.viewer && this.props.viewer.user &&
            <UserPanel
              viewer={this.props.viewer}
              user={this.props.viewer.user}
              userStatusList={this.props.userStatusList.enumValues}
              certificateValidationStatusList={this.props.certificateValidationStatusList.enumValues}
              onUpdateUser={this.onUpdateUser}
              router={router}
              text="Update"/>
          }
        </div>
    );
  }

}

export default Relay.createContainer(EditUser, {
  initialVariables: {
    userId: null,
    queryUser: false,
  },
  fragments: {
    userStatusList: () => Relay.QL`fragment on __Type {enumValues {name description}}`,
    certificateValidationStatusList: () => Relay.QL`fragment on __Type {enumValues {name description}}`,
    viewer: () => Relay.QL`
      fragment on Viewer {
        user (id: $userId) @include(if: $queryUser) {
          ${UserPanel.getFragment('user')}
        }
        ${UpdateUserMutation.getFragment('viewer')}
        ${UserPanel.getFragment('viewer')}
      }
      `,
  }
});



// WEBPACK FOOTER //
// ./src/pages/User/EditUser.js